export default "__VITE_ASSET__ee956d64__"